export default {
  'OrdersActionTableHeader.Buttons.AssignToTech': ({ }, outlet) => {
    outlet({ action: 'assign_tech' });
  },
  'OrdersActionTableHeader.Buttons.AssignToVendor': ({ }, outlet) => {
    outlet({ action: 'assign_vendor' });
  },
  'OrdersActionTableHeader.Buttons.CancelOrders': ({ }, outlet) => {
    outlet({ action: 'cancel' });
  },
  'OrdersActionTableHeader.Buttons.UnassignOrders': ({ }, outlet) => {
    outlet({ action: 'unassign' });
  },
  'OrdersActionTableHeader.Buttons.ReopenOrders': ({ }, outlet) => {
    outlet({ action: 'reopen' });
  },
  'OrdersActionTableHeader.Checkbox.Checkbox': ({ }, outlet) => {
    outlet({ action: 'toggle' })
  },
  'OrdersActionTableHeader.Checkbox.Button': ({ }, outlet) => {
    outlet({ action: 'empty_selection' })
  }
}